import {
	StepperSelectionEvent,
	STEPPER_GLOBAL_OPTIONS
} from "@angular/cdk/stepper";
import { Component, HostListener, ViewChild, OnInit } from "@angular/core";
import {
	UntypedFormArray,
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators
} from "@angular/forms";
import { MatLegacyCheckboxChange as MatCheckboxChange } from "@angular/material/legacy-checkbox";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { map, Observable, startWith, firstValueFrom } from "rxjs";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { TransferOwnershipDataService } from "src/app/share/data-service/transfer-ownership.data.service";
import { FileFunction } from "src/app/share/function/file.function";
import { ValidatorFunction } from "src/app/share/function/validator.function";
import {
	ProductAddOnInterface,
	QuotationInterface,
	MotorRequestInterface,
	PromoCodeInterface,
	ProductDocumentInterface,
	MotorAddOnCARTPriceInterface,
	ChubbGenQuotationInfoInterface
} from "src/app/share/interface/motor.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { PartnerService } from "src/app/share/service/partner.service";
import { AgentCodeDialogComponent } from "../agent-code-dialog/agent-code-dialog.component";
import { BenefitDialogComponent } from "../benefit-dialog/benefit-dialog.component";
import { CarDetailsDialogComponent } from "../car-details-dialog/car-details-dialog.component";
import { CarPlanDialogComponent } from "../car-plan-dialog/car-plan-dialog.component";
import { DealerCaseDialogComponent } from "../dealer-case-dialog/dealer-case-dialog.component";
import { EditQuotationsComponent } from "../edit-quotations/edit-quotations.component";
import { SubmitSuccessDialogComponent } from "../submit-success-dialog/submit-success-dialog.component";
import {
	BUSINESS_TYPE,
	GENDER_TYPE,
	ID_TYPE,
	MARITAL_STATUS,
	SUM_INSURED_TYPE
} from "src/app/share/constants/common.types";
import { CarVariantDialogComponent } from "../car-variant-dialog/car-variant-dialog.component";
import { CommonFunction } from "src/app/share/function/common.function";
import { INSURER_CODE, INSURER_FULL_NAME } from "src/app/share/constants/common.info";
import { INSURER_CAR_PLUS_PACKAGE } from "src/app/share/constants/insurer-car-plus";
import { POLICYSTREET_CARE_PLUS_PACKAGE } from "src/app/share/constants/policystreet-care-plus";

declare global {
	interface Window {
		dataLayer: any[];
	}
}

@Component({
	selector: "app-comparison",
	templateUrl: "./comparison.component.html",
	styleUrls: ["./comparison.component.scss"],
	providers: [
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false }
		}
	]
})
export class ComparisonComponent {
	partnerCode: string = "carsomeCapital";
	screenWidth: number;

  /* Insurer Car Plus */
  readonly _insurerCarPlusPackage = INSURER_CAR_PLUS_PACKAGE; // Will move to DB if there are more
  insurerCarPlusPackage: any;
  insurerCarPlusSettings: any;
  selectedInsurerCarPlusPackage: any;
  availableInsurerCarPlus: any;  // Data from db
  selectedAvailableInsurerCarPlus: any;
  showAllBenefits = false;
  benefitsLimit = 3;
  isCarPlusChecked: boolean = false;

  /* PolicyStreet Care+ (partner bundle, add-on category PSCAREPLUS) */
  readonly _psCarePlusPackage = POLICYSTREET_CARE_PLUS_PACKAGE;
  psCarePlusSettings: any;
  availablePsCarePlus: ProductAddOnInterface[] = []; // Data from db
  selectedPsCarePlus: any; // matches selectedAvailableInsurerCarPlus above
  isPsCarePlusChecked: boolean = false;

  //Custom Config By Insurer
  showTypeOfSumValue: string = "MV";
  showISMRecommended: boolean = false;
  showEffectivePeriod: boolean = false;
  showAgencyCommission: boolean = false;

	quotationFrmGroup: UntypedFormGroup;
	addOnFrmGroup: UntypedFormGroup;
	infoFrmGroup: UntypedFormGroup;
	agreementFrmGroup: UntypedFormGroup;
	paymentFrmGroup: UntypedFormGroup;

	id: string;
	requestData: MotorRequestInterface;
	quotationList: QuotationInterface[] = [];
	quotationId: string;
	selectedQuotation: QuotationInterface;
	quotationToPrint: QuotationInterface;

  // Insurer Flags
  isTakaful: boolean = false;

	@ViewChild("stepper") stepper: MatStepper;

	addOnList: ProductAddOnInterface[] = [];
	includeAddOnList: ProductAddOnInterface[] = [];

	addOnOptionalCategory: string[] = [];

	selectedAddOn: any = [];
  selectedNonSSTAddOnToDisplay: any[] = [];

	isFloodChecked: boolean;
	isDriverChecked: boolean;

	personalInfo: any;

	relationshipList = [
		{ id: "Parent/Parent-in-law", name: "common.parents" },
		{ id: "Spouse", name: "common.spouse" },
		{ id: "Son/Daughter", name: "common.child" },
		{ id: "Sibling/Sibling-in-law/Cousin/Relative", name: "common.sibling" },
		{ id: "Friend/Co-worker", name: "common.friend" }
	];

	hirePurchaseList = [];
	filteredHirePurchase: Observable<string[]>;

	dealerOutletsList: string[] = ["Others"];
	filteredDealerOutletsList: Observable<string[]>;

	promoCode: string;
	promo: PromoCodeInterface;
	promoError: string;
  promoMinAmount: number;
  promoMaxAmount: number;

	showRoadTaxList: boolean = false;
	isIncludeDigitalRoadtax: boolean = true;
	includeDigitalRoadTax: boolean;


	stateList: string[] = [
		"Selangor",
		"Kuala Lumpur",
		"Johor",
		"Kedah",
		"Kelantan",
		"Melaka",
		"Negeri Sembilan",
		"Pahang",
		"Perak",
		"Perlis",
		"Pulau Pinang",
		"Sarawak",
		"Sabah",
		"Terengganu",
		"Putrajaya"
	];

	filterStateList: string[] = Object.assign([], this.stateList);
	filterDeliveryStateList: string[] = Object.assign([], this.stateList);

	productDocumentInterface: ProductDocumentInterface[] = [];

	selectedPayment: string = "Razer";
	allowEditQuotation: boolean = false;

	isSameAddressCheck: boolean;

	otherInsurersList: string[] = [
		"Allianz",
		"am",
		"greateastern",
		"kurnia",
		"liberty",
		"longpac",
		"Msig",
		"Rhb",
		"tokio"
	];

	uniquePageView: any[] = [
		{
			index: 0,
			pageTitle: "comparison page"
		},
		{
			index: 1,
			pageTitle: "add ons page"
		},
		{
			index: 2,
			pageTitle: "user details page"
		},
		{
			index: 3,
			pageTitle: "order summary page"
		}
	];

	fgapAddOnsIndex: string = "0";

	idTypeOption = ID_TYPE;
	maritalStatusOption = MARITAL_STATUS;
	genderOption = GENDER_TYPE;
	businessTypeOption = BUSINESS_TYPE;

	maxAdditionalDriver: number;
	fgapPriceList: number[];
	windshieldMin: any;
	windshieldMax: any;
	ewpMileagePrice: number = 0;
	ewpMileageMax: number = 0;

	// images
	mykadOrPassport: any[] = [];
	letterOfUndertaking: any[] = [];
	vehiclePhoto: any[] = [];
	ewpFiles = {
		mileageImage: [],
		vehRegCard: [],
		vehInsReport: []
	};

	numberOfLltpSeats: number = 0;
	isChubbIQ: boolean = false;
	isGeneraliIQ: boolean = false;
	isZurichIQ: boolean = false;
	isTMIMIQ: boolean = false;
	isForPremiumRecalculate: boolean = false;
	isRecalculate: boolean = false;
	chubbIQQuotationNo: string = "";
  isAllianzIQ: boolean = false;
  isAllianzIQValidated: boolean = false;

	idTypeList: FieldData[] = [
		{ codeValue: "IC_NO", codeDesc: "IC Number" },
		{ codeValue: "PASSPORT", codeDesc: "Passport" },
		{ codeValue: "POLICE/ARMY", codeDesc: "Police/Army" }
	];

	cartDayList: FieldData[] = [
    { codeValue: "7", codeDesc: "7" },
    { codeValue: "14", codeDesc: "14" },
    { codeValue: "21", codeDesc: "21" }
  ];

  cartDailyCoverageList: FieldData[] = [
    { codeValue: "50", codeDesc: "RM 50" },
    { codeValue: "100", codeDesc: "RM 100" },
    { codeValue: "200", codeDesc: "RM 200" }
  ];

	cartAddOnPriceList: MotorAddOnCARTPriceInterface[] = [];
  selectedCartDays: string;
  selectedCartDailyCoverage: string;
  minGCKTCoverage: number = 0;
  minVACoverage: number = 0;

	maxDob: Date = new Date();
	currentDate: Date = new Date();
	
  isAgree: boolean = false;
  declarationList: any[];
  declarationCheckboxController = [
      {
          checkbox: "isRead",
          checked: false,
          acknowledgement: "common.acknowledgementConfirmationOne"
      },
      { 
          checkbox: "isConfirm",
          checked: false,
          acknowledgement: "common.acknowledgementConfirmationTwo",
      },
      // { 
      //     checkbox: "isDirectMarketing",
      //     checked: false,
      //     acknowledgement: "common.acknowledgementConfirmationThree"
      // }
  ];
  motorProductDoc: any;

	constructor(
		private gtmService: GoogleTagManagerService,
		public translate: TranslateService,
		private alertService: AlertService,
		private formBuilder: UntypedFormBuilder,
		private activatedRoute: ActivatedRoute,
		private ngxSpinnerService: NgxSpinnerService,
		private partnerService: PartnerService,
		private motorDataDataService: MotorDataDataService,
		private transferOwnershipDataService: TransferOwnershipDataService,
		private router: Router,
		private dialog: MatDialog
	) {
		this.getPartnerCode();

		this.initQuotationForm();
		this.initAddOnForm();
		this.initInfoForm();
		this.initAgreementForm();
		this.initPaymentForm();

		this.screenWidth = window.innerWidth;
		this.id = activatedRoute.snapshot.params.id;

		this.getPersonalInfo();

		if (this.isUUID(this.id)) {
			this.allowEditQuotation =
				activatedRoute.snapshot.queryParams.editQuotation;
			this.getDetailById();
		} else {
			window.location.href = "/";
		}
		this.translate.onLangChange.subscribe((x) => {
			if (this.selectQuotation) {
				this.getProductDocument();
			}
		});
		this.gtmService.pushTag({
			event: "car_step1"
		});

		// Unique page view tracking for certain affiliate (Comparison page on render)
		if (
			this.partnerService.getPartnerAttribute(
				this.partnerCode,
				"uniquePageViews"
			)
		) {
			window.dataLayer.push({
				event: "virtualPageview",
				pageUrl: window.location.href,
				pageTitle: `${this.partnerCode} comparison page`
			});
		}
	}

	@HostListener("window:resize", ["$event"])
	onResize(event) {
		this.screenWidth = event.target.innerWidth;
	}

	private getPartnerCode() {
		this.partnerCode = this.partnerService.getPartnerCode();
		!this.partnerCode ? (this.partnerCode = "carsomeCapital") : null;
	}

	private initQuotationForm() {
		this.quotationFrmGroup = new UntypedFormGroup({
			id: new UntypedFormControl(this.quotationId, [Validators.required])
		});
	}

	private initAddOnForm() {
		this.getCARTAddOnPriceList();
		
		this.addOnFrmGroup = new UntypedFormGroup({
			windshield: new UntypedFormControl(),
			drivers: new UntypedFormArray([]),
			fgap: new UntypedFormControl(),
			ewp: new UntypedFormControl(),
			isIncludeRoadtax: new UntypedFormControl(),
			isNotBlacklisted: new UntypedFormControl(null),
			isWindshieldExceeded: new UntypedFormControl(null),
			lltpSeats: new UntypedFormControl(this.numberOfLltpSeats[0]),
			cartDays: new UntypedFormControl(),
			cartDailyCoverage: new UntypedFormControl(),
			gckt: new UntypedFormControl(),
			va: new UntypedFormControl()
		});

		this.addOnFrmGroup.valueChanges.subscribe(() => {
			this.applyPromoCode();
		});

		this.addOnFrmGroup.controls.isIncludeRoadtax.valueChanges.subscribe((x) => {
			let validators = [];
			let addressValidators = [];
			if (x) {
				validators = [Validators.requiredTrue];
				addressValidators = [Validators.required];
				this.infoFrmGroup.controls.deliveryPostcode.enable();
			} else {
				this.addOnFrmGroup.controls.isNotBlacklisted.reset();
				this.infoFrmGroup.controls.deliveryPostcode.enable();
			}
			this.addOnFrmGroup.controls.isNotBlacklisted.setValidators(validators);
			this.addOnFrmGroup.controls.isNotBlacklisted.updateValueAndValidity();

			this.infoFrmGroup.controls.deliveryAddress.setValidators(
				addressValidators
			);
			this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();

			this.infoFrmGroup.controls.deliveryAddress2.setValidators(
				addressValidators
			);
			this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();

			this.infoFrmGroup.controls.deliveryCity.setValidators(addressValidators);
			this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();

			this.infoFrmGroup.controls.deliveryPostcode.setValidators(
				addressValidators
			);
			this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();

			this.infoFrmGroup.controls.deliveryState.setValidators(addressValidators);
			this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
		});
		this.addOnFrmGroup.get('windshield')?.valueChanges.subscribe(() => {
      this.clearPromoCode();
    });

		this.addOnFrmGroup.controls.cartDays.valueChanges.subscribe(
      (x) => {
        if (x) {
          this.selectedCartDays = x;
        }
      }
    );

    this.addOnFrmGroup.controls.cartDailyCoverage.valueChanges.subscribe(
      (x) => {
        if (x) {
          this.selectedCartDailyCoverage = x;
        }
      }
    );
	}

	private initInfoForm() {
		this.infoFrmGroup = new UntypedFormGroup({
			name: new UntypedFormControl(null, [Validators.required]),
			occupation: new UntypedFormControl(null, []),
			mobileNo: new UntypedFormControl(null, [Validators.required]),
			email: new UntypedFormControl(null, [Validators.required, Validators.email]),
			address: new UntypedFormControl(null, [Validators.required]),
			address2: new UntypedFormControl(null, [Validators.required]),
			city: new UntypedFormControl(null, [Validators.required]),
			postcode: new UntypedFormControl(null, [Validators.required]),
			state: new UntypedFormControl(null, [Validators.required]),

			financingType: new UntypedFormControl("BankLoan", [Validators.required]),
			bank: new UntypedFormControl(""),
			effectiveDate: new UntypedFormControl(null, [Validators.required]),
			dealerCase: new UntypedFormControl(false, [Validators.required]),
			dealerOutlets: new UntypedFormControl(null),
			customDealerOutlet: new UntypedFormControl(null),

			deliveryAddress: new UntypedFormControl(null),
			deliveryAddress2: new UntypedFormControl(null),
			deliveryCity: new UntypedFormControl(null),
			deliveryPostcode: new UntypedFormControl(null),
			deliveryState: new UntypedFormControl(null)
		});
		this.infoFrmGroup.controls.postcode.disable();

		// Delete bank/hirepurchaselist if cash is selected
		this.infoFrmGroup.controls.financingType.valueChanges.subscribe((value) => {
			if (value == "Cash") {
				this.infoFrmGroup.patchValue({
					bank: null
				});
			}
		});

		if (this.partnerCode == "carsomeCapital") {
			// Dealer outlet required if its a dealer case
			this.infoFrmGroup.controls.dealerCase.valueChanges.subscribe((value) => {
				if (value == true) {
					this.infoFrmGroup.controls.dealerOutlets.setValidators([
						Validators.required
					]);
				} else {
					this.infoFrmGroup.controls.dealerOutlets.clearValidators();
					this.infoFrmGroup.controls.customDealerOutlet.clearValidators();
				}
				this.infoFrmGroup.controls.dealerOutlets.updateValueAndValidity();
				this.infoFrmGroup.controls.customDealerOutlet.updateValueAndValidity();
			});

			// Custom dealer case required if Others is picked on dealer outlet
			this.infoFrmGroup.controls.dealerOutlets.valueChanges.subscribe(
				(value) => {
					if (this.infoFrmGroup.value.dealerCase && value == "Others") {
						this.infoFrmGroup.controls.customDealerOutlet.setValidators([
							Validators.required
						]);
					} else {
						this.infoFrmGroup.controls.customDealerOutlet.clearValidators();
					}

					this.infoFrmGroup.controls.customDealerOutlet.updateValueAndValidity();
				}
			);
		}
	}

	private initAgreementForm() {
		this.agreementFrmGroup = new UntypedFormGroup({
			agreeInfo: new UntypedFormControl(false, [Validators.requiredTrue]),
			doc: new UntypedFormArray([]),
      marketingConsent: new UntypedFormControl(false)
		});
	}

  get insurerFullName(): string {
    if (this.selectedQuotation && this.selectedQuotation.code) {
        return INSURER_FULL_NAME[this.selectedQuotation.code];
    }

    return "";
  }

	private getPersonalInfo() {
    this.motorDataDataService
      .getDetailById(this.id)
      .pipe()
      .subscribe({
        next: (x) => {
          this.personalInfo = x;
          this.getResidentialAddressData();
        },
        error: (err) => {
					this.alertService.openSnackBar(err.error);
        }
      });
  }

	getResidentialAddressData() {
    if (this.isValidAddressValue(this.personalInfo.address)) {
      this.infoFrmGroup.controls.address.setValue(this.personalInfo.address);
    }
     if (this.isValidAddressValue(this.personalInfo.address2)) {
        this.infoFrmGroup.controls.address2.setValue(this.personalInfo.address2);
    }
    if (this.isValidAddressValue(this.personalInfo.city)) {
        this.infoFrmGroup.controls.city.setValue(this.personalInfo.city);
    }
    if (this.isValidAddressValue(this.personalInfo.state)) {
        this.infoFrmGroup.controls.state.setValue(this.personalInfo.state);
    }
  }

	private isValidAddressValue(value: any): boolean {
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  insurerDeclarationDoc() {
    let additionalDoc = "";
    
    if (this.selectedQuotation?.code == INSURER_CODE.Chubb) {
      additionalDoc = "assets/doc/ChubbDeclarationDoc.pdf";
    }

    return {
      motorProductDoc: this.motorProductDoc,
      additionalDoc: additionalDoc
    }
  }

	private initPaymentForm() {
		this.paymentFrmGroup = new UntypedFormGroup({
			payment: new UntypedFormControl(false, Validators.requiredTrue)
		});
	}

	private isUUID(uuid: string) {
		return uuid.match(
			"^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
		);
	}

	private getDetailById() {
		this.motorDataDataService.getDetailById(this.id).subscribe({
			next: (x: any) => {
				this.translate.use(x.language);
				this.requestData = x;
				this.getQuotation();
				this.infoFrmGroup.controls.name.setValue(x.name);
				this.infoFrmGroup.controls.email.setValue(x.email);
				this.infoFrmGroup.controls.mobileNo.setValue(x.mobileNo);
				this.infoFrmGroup.controls.postcode.setValue(x.postcode);

				if (x && x.businessType == this.businessTypeOption.transferOwnership) {
					this.infoFrmGroup
						.get("financingType")
						.setValidators(Validators.required);
					this.infoFrmGroup
						.get("effectiveDate")
						.setValidators(Validators.required);
					this.infoFrmGroup
						.get("dealerCase")
						.setValidators(Validators.required);
				} else {
					this.infoFrmGroup.get("financingType").clearValidators();
					this.infoFrmGroup.get("effectiveDate").clearValidators();
					this.infoFrmGroup.get("dealerCase").clearValidators();
				}
				this.infoFrmGroup.get("financingType").updateValueAndValidity();
				this.infoFrmGroup.get("effectiveDate").updateValueAndValidity();
				this.infoFrmGroup.get("dealerCase").updateValueAndValidity();
				this.numberOfLltpSeats = x.seat;
				if (this.numberOfLltpSeats <= 4){
          this.numberOfLltpSeats = 5
        }
				this.addOnFrmGroup.controls.lltpSeats.setValue(this.numberOfLltpSeats);
			},
			error: () => {
				window.location.href = "/";
			}
		});
	}

	private calculateQuotationTotalPrice(): void {
    this.quotationList.forEach(x => {
        const carPlusPrice = x.code === 'Chubb' ? 35 : 0;
        const basePremium = x.totalBasePremium + carPlusPrice;
        const charges = basePremium * (1 + x.taxRate) + x.stampDutyPrice;
        x.totalPrice = charges * (1 + x.serviceTaxRate);
    });
	}

	private getQuotation() {
		this.motorDataDataService.getQuotationById(this.id).subscribe({
			next: (x) => {
				this.quotationList = x;
				this.calculateQuotationTotalPrice();
				if (this.activatedRoute.snapshot.queryParams.id) {
					setTimeout(() => {
						this.selectQuotation(this.activatedRoute.snapshot.queryParams.id);
					}, 100);
				}
				if (this.allowEditQuotation) {
					this.editQuotation();
					this.allowEditQuotation = false;
				}
			},
			error: () => {
				window.location.href = "/";
			}
		});
	}

	private getAddOn() {
		this.includeAddOnList = [];
		this.motorDataDataService.getAddOn(this.id, this.quotationId).subscribe({
			next: (x) => {
				this.addOnList = x;

        		this.initInsurerCarPlus();
        		this.initPolicyStreetCarePlus();
        
				if (this.addOnList) {
					this.sortDriversAddonSequence();
				}
				this.addOnOptionalCategory = [
					...new Set(
						this.addOnList.filter((y) => !y.included).map((z) => z.category)
					)
				];
				this.addOnList.forEach((y: any) => {
					if (y.category == "Windshield") {
						this.windshieldMin = this.getMinMaxWindscreenPrice(y, "min");
						this.windshieldMax = this.getMinMaxWindscreenPrice(y, "max");

						this.addOnFrmGroup.controls.windshield.setValue(
							this.windshieldMin || 500
						);
					}

					if (y.code == "AdditionalDrivers") {
						this.maxAdditionalDriver = this.getRule(y)?.max ?? null;
					}

					if (y.code == "FGAP") {
						this.fgapPriceList = eval(y.evaluate);
						if (this.fgapPriceList)
							this.addOnFrmGroup.controls.fgap.setValue(this.fgapPriceList[0]);
					}

					if (y.code == "EWP") {
						let conditionList = eval(y.condition);
						this.ewpMileageMax = conditionList[conditionList.length - 1].Max;

						this.selectedAddOn.push(y);
						this.addOnFrmGroup.controls.ewp.setValidators([
							Validators.max(this.ewpMileageMax),
							Validators.required
						]);
					}
					this.addOnFrmGroup.controls.ewp.updateValueAndValidity();

					if (y.category == "CART") {
            this.selectedCartDays = this.cartDayList[0].codeValue;
            this.selectedCartDailyCoverage = this.cartDailyCoverageList[0].codeValue;
            this.addOnFrmGroup.controls.cartDays.setValue(this.selectedCartDays);
            this.addOnFrmGroup.controls.cartDailyCoverage.setValue(this.selectedCartDailyCoverage);
          }

          if (y.category == "GCKT") {
            this.minGCKTCoverage = this.getRule(y)?.min ?? null;
            this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
          }

          if (y.category == "VA") {
            this.minVACoverage = this.getRule(y)?.min ?? null;
            this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
          }

					if (y.included) {
						this.includeAddOnList.push(y);
						this.selectedAddOn.push(y);
					}
				});
			},
			error: () => {
				window.location.href = "/";
			}
		});
	}

	sortDriversAddonSequence() {
		// Define the custom order for specific codes
		const order = ["UnlimitedDrivers", "AdditionalDrivers"];

		this.addOnList.sort((a, b) => {
			// Handle custom sorting logic
			const indexA = order.indexOf(a.code);
			const indexB = order.indexOf(b.code);

			if (indexA > -1 && indexB > -1) {
				return indexA - indexB; // Both are in the order list
			} else if (indexA > -1) {
				return -1; // a should come before b
			} else if (indexB > -1) {
				return 1; // b should come before a
			} else {
				return 0; // Default sorting for other items
			}
		});
	}

	fgapAddOnsChanged(index: string) {
		this.fgapAddOnsIndex = index;
	}

	step2DisableBtnCondition() {
		// IF EWP Add On Selected, this is the btn disable condition
		if (this.selectedAddOn.find((e) => e.category == "EWP")) {
			if (
				this.addOnFrmGroup.valid &&
				this.ewpFiles.mileageImage.length &&
				this.ewpFiles.vehRegCard.length &&
				this.ewpFiles.vehInsReport.length
			) {
				return false;
			}
		}
		// If no add on selected, this is the btn disable condition
		else if (this.addOnFrmGroup.valid) {
			return false;
		}
		return true;
	}

	private getProductDocument() {
		if (!this.selectedQuotation) return;
		this.productDocumentInterface = [];
		let frmArray = this.getAgreeFormArray();
		frmArray.clear();
		this.motorDataDataService
			.getProductDocumentById(
				this.selectedQuotation.productId,
				this.translate.currentLang,
				this.requestData.insuranceType
			)
			.subscribe({
				next: (x) => {
					this.productDocumentInterface = x;

          this.motorProductDoc = {
            productDisclosureSheet: this.productDocumentInterface.find(x => x.code == "productDisclosureSheet")?.url,
            dutyOfDisclosure: this.productDocumentInterface.find(x => x.code == "dutyOfDisclosure")?.url,
            policyWording: this.productDocumentInterface.find(x => x.code == "policyWording")?.url,
            privacyNotice: this.productDocumentInterface.find(x => x.code == "privacyNotice")?.url,
          };

					x.forEach((doc) => {
						if (doc.neededUserAgree) {
							let frm = this.formBuilder.group({
								checked: new UntypedFormControl(false, [Validators.requiredTrue]),
								name: new UntypedFormControl(doc.name),
								url: new UntypedFormControl(doc.url)
							});
							frmArray.push(frm);
						}
					});
				}
			});
	}

	private promoCheck() {
		if (!this.promo) return;
		if (
			this.promo.customCode == "RoadTaxDelivery" &&
			!this.addOnFrmGroup.value.isIncludeRoadtax
		) {
			this.promo = null;
			this.promoError = "InvalidPromoCode";
		}
	}

	onStepChange(e: StepperSelectionEvent) {
		this.gtmService.pushTag({
			event: "car_step" + (e.selectedIndex + 1)
		});

		this.paymentFrmGroup.controls.payment.setValue(e.selectedIndex == 4);
		if (e.selectedIndex == 3) {
			let value = this.infoFrmGroup.getRawValue();
			if (
				this.addOnFrmGroup.value?.isIncludeRoadtax &&
				this.isSameAddressCheck
			) {
				this.infoFrmGroup.controls.deliveryAddress.setValue(value.address);
				this.infoFrmGroup.controls.deliveryAddress2.setValue(value.address2);
				this.infoFrmGroup.controls.deliveryCity.setValue(value.city);
				this.infoFrmGroup.controls.deliveryPostcode.setValue(value.postcode);
				this.infoFrmGroup.controls.deliveryState.setValue(value.state);
			} else if (!this.addOnFrmGroup.value?.isIncludeRoadtax) {
				this.infoFrmGroup.controls.deliveryAddress.reset();
				this.infoFrmGroup.controls.deliveryAddress2.reset();
				this.infoFrmGroup.controls.deliveryCity.reset();
				this.infoFrmGroup.controls.deliveryPostcode.reset();
				this.infoFrmGroup.controls.deliveryState.reset();

				this.infoFrmGroup.controls.deliveryAddress.setValidators([]);
				this.infoFrmGroup.controls.deliveryAddress2.setValidators([]);
				this.infoFrmGroup.controls.deliveryCity.setValidators([]);
				this.infoFrmGroup.controls.deliveryPostcode.setValidators([]);
				this.infoFrmGroup.controls.deliveryState.setValidators([]);

				this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
			}
		}
		if (e.selectedIndex == 1 || e.selectedIndex == 2) {
			this.applyPromoCode();
		}

		if (e.selectedIndex == 2) this.getListDropdowns();

		// Unique page view tracking for certain affiliate
		if (
			this.partnerService.getPartnerAttribute(
				this.partnerCode,
				"uniquePageViews"
			)
		) {
			this.uniquePageView.forEach((x) => {
				if (e.selectedIndex == x.index) {
					window.dataLayer.push({
						event: "virtualPageview",
						pageUrl: window.location.href,
						pageTitle: `${this.partnerCode} ${x.pageTitle}`
					});
				}
			});
		}

    // Recalculate premiums when customer navigate from Add On page to Personal Details page
    //  - applied for: Chubb
    if ((this.isChubbIQ || this.isGeneraliIQ || this.isZurichIQ || this.isTMIMIQ || this.isAllianzIQ) && e.previouslySelectedIndex == 1){
			this.isForPremiumRecalculate = true;
      this.recalculateInstantQuotationPricing();
		}

		// Re-run TMIM's GET PREM before proceeding to payment
		//	- this round is mainly for Transfer Ownership cases with Hire Purchase financing selected
		//	- TMIM's LOAN COM capturing is in GET PREM, execute it when user proceed from Personal Details page
		if (this.isTMIMIQ && this.infoFrmGroup.value.financingType == "BankLoan" && e.previouslySelectedIndex == 2 && e.selectedIndex == 3){
			this.isForPremiumRecalculate = false;
			this.recalculateInstantQuotationPricing();
		}
	}

	recalculateInstantQuotationPricing() {
		// Recalculate premiums is required for IQ due to addons (extra coverages)
		//  - when user selected 1 or more addons, the premiums for the addons will be retrieved from API
		//  - this function mainly reset the 'evaluate' with premiums calculated from API for the addons

		/* 2 Apr 2026 - Update Notes
			- Added [isRecalculate] flag
			- Issue: when selectedAddOn = 0, it will not be able to update Hire Purchase Loan Info
		*/
		if ((this.selectedAddOn && this.selectedAddOn.length > 0) || this.isCarPlusChecked || this.isRecalculate) {
			this.ngxSpinnerService.show();

			if (this.isChubbIQ) {
				this.motorDataDataService.getChubbQuotationPricing(
					this.selectedQuotation.id,
					this.selectedAddOn,
					this.addOnFrmGroup.value.windshield,
          			this.isCarPlusChecked ? this.selectedAvailableInsurerCarPlus.insurerCustomCode : "LO"
				).subscribe({
					next: (x: any) => {
						this.selectedAddOn = x.addOn;
            
						this.selectedAvailableInsurerCarPlus = {
						...this.selectedAvailableInsurerCarPlus,
						evaluate: x.plan.planPremium
						};

						this.ngxSpinnerService.hide();
					},
					error: (err) => {
						this.alertService.openSnackBar("Premium calculation failed, please contact Policy Street.");
						this.ngxSpinnerService.hide();
						this.stepper.selectedIndex = 1;
					}
				});
			}
			else if (this.isGeneraliIQ) {
				this.motorDataDataService.getGeneraliQuotationPricing(
					this.quotationId,
					this.selectedAddOn,
					this.addOnFrmGroup.value.drivers,
					this.addOnFrmGroup.value.windshield,
					this.addOnFrmGroup.value.gckt,
					this.addOnFrmGroup.value.cartDays,
					this.addOnFrmGroup.value.cartDailyCoverage
				).subscribe({
					next: (x: any) => {
						this.selectedAddOn = x as any[];
						this.ngxSpinnerService.hide();
					},
					error: () => {
						this.alertService.openSnackBar("Premium calculation failed, please contact Policy Street.");
						this.ngxSpinnerService.hide();
						this.stepper.selectedIndex = 1;
					}
				});
			}
			else if (this.isZurichIQ) {
				// after selecting addons, run GET PREM again to update Zurich's quotation with selected addons
				//	- and apply the addon premiums back to FE
				//	- personal details and finance details is not needed at this point, will be handled during Submit()
				this.motorDataDataService.getZurichQuotationPricing(
					this.quotationId,
					this.selectedAddOn,
					this.addOnFrmGroup.value.drivers,
					this.addOnFrmGroup.value.windshield,
					"", "", "", false, "", null
				).subscribe({
					next: (x: any) => {
						this.selectedAddOn = x.selectedAddOn as any[];
						this.selectedQuotation.basePremium = x.basePremium;
						this.selectedQuotation.totalBasePremium = x.totalBasePremium;
						this.requestData.effectiveDate = this.infoFrmGroup.value.effectiveDate;

						this.ngxSpinnerService.hide();
					},
					error: (err: any) => {
						let errMsg = "Premium calculation failed, please contact Policy Street.";
						if (err.error) errMsg = err.error;
						this.alertService.openSnackBar(errMsg);
						this.ngxSpinnerService.hide();
						this.stepper.selectedIndex = 1;
					}
				});
			}
			else if (this.isTMIMIQ) {
				let driverCount = 0;
				
				if (this.selectedAddOn.some((i) => i.insurerCustomCode === "E303")) {
					driverCount = (this.addOnFrmGroup.get("drivers") as UntypedFormArray)?.length ?? 0;
				}

				let isHirePurchase = (!this.isForPremiumRecalculate && this.requestData.businessType == this.businessTypeOption.transferOwnership && this.infoFrmGroup.value.financingType == "BankLoan");
				let loanComName = (isHirePurchase) ? this.infoFrmGroup.value.bank : "";
				
				this.motorDataDataService.getTMIMQuotationPricing(
					this.selectedQuotation.id,
					this.selectedAddOn,
					this.addOnFrmGroup.value.windshield,
					driverCount,
					isHirePurchase,
					loanComName
				).subscribe({
					next: (x) => {
						this.selectedAddOn = x as any[];
						this.ngxSpinnerService.hide();
          },
          error: (err: any) => {
            let errMsg = "Premium calculation failed, please contact Policy Street.";
            if (err.error) errMsg = err.error;
            this.alertService.openSnackBar(errMsg);
						this.ngxSpinnerService.hide();
						this.stepper.selectedIndex = 1;
					}
				});
			}
			else if (this.isAllianzIQ) {
				this.motorDataDataService.getAllianzQuotationPricing(
					this.quotationId,
					this.selectedAddOn,
					this.addOnFrmGroup.value.windshield,
					this.addOnFrmGroup.value.cartDays,
					this.addOnFrmGroup.value.cartDailyCoverage,
					this.addOnFrmGroup.value.gckt,
					this.addOnFrmGroup.value.drivers
				).subscribe({
					next: (x: any) => {
						this.selectedAddOn = x as any[];
						this.ngxSpinnerService.hide();
					},
					error: () => {
						this.alertService.openSnackBar("Premium calculation failed, please contact Policy Street.");
						this.ngxSpinnerService.hide();
						this.stepper.selectedIndex = 1;
					}
				});
			}
		}
	}

	applyPromoCode() {
		if (!this.promoCode) return;
		this.ngxSpinnerService.show();
		this.promoError = null;
		this.promo = null;
		this.motorDataDataService
			.applyPromoCode(this.id, this.promoCode, this.getTotalCharge())
			.subscribe({
				next: (x) => {
					this.promo = x;
					this.ngxSpinnerService.hide();
					this.promoCheck();
				},
				error: (err) => {
					this.ngxSpinnerService.hide();
					this.promoError = err.error.message;

          if (err.error.message === "InsufficientPromoCodeMinAmount"){
            this.promoMinAmount = Number(err.error.parameters[0]);
          }

          if (err.error.message === "InsufficientPromoCodeMaxAmount"){
            this.promoMaxAmount = Number(err.error.parameters[0]);
          }
				}
			});
	}

	clearPromoCode() {
		this.promoCode = null;
		this.promoError = null;
		this.promo = null;
	}

	getFormArray() {
		return this.addOnFrmGroup.get("drivers") as UntypedFormArray;
	}

	getAgreeFormArray() {
		return this.agreementFrmGroup.get("doc") as UntypedFormArray;
	}

	addDriver() {
		let frmArray = this.getFormArray();
		let form = this.formBuilder.group({
			name: [null, Validators.required],
			idType: [this.idTypeList[0].codeValue, Validators.required],
			identityNo: [
				null,
				[Validators.required, ValidatorFunction.nricValidator()]
			],
			dob: [null, Validators.required],
			gender: [this.genderOption.male, Validators.required],
			maritalStatus: [this.maritalStatusOption.single, Validators.required],
			relationship: [null, Validators.required],
			isMalaysian: [true]
		});

		form.get("idType").valueChanges.subscribe((value) => {
			if (value === "IC_NO") {
				form
					.get("identityNo")
					.setValidators([
						Validators.required,
						ValidatorFunction.nricValidator()
					]);
			} else {
				form.get("identityNo").setValidators(Validators.required);
			}

			if (["IC_NO", "POLICE/ARMY"].includes(value)) {
				form.get("isMalaysian").patchValue(true);
			} else {
				form.get("isMalaysian").patchValue(false);
			}

			form.get("identityNo").reset();
			form.get("identityNo").updateValueAndValidity();
		});

		form.get("identityNo").valueChanges.subscribe((value) => {
			if (
				form.get("identityNo").invalid &&
				form.get("idType").value === "IC_NO"
			) {
				form.get("dob").reset();
			}

			if (
				form.get("identityNo").valid &&
				form.get("idType").value === "IC_NO"
			) {
				let date = moment(value.substring(0, 6), "YYMMDD");
				let lastChar = value.substring(11);
				let gender = lastChar % 2 ? "M" : "F";

				if (moment().isBefore(date)) {
					date.subtract(100, "year");
				}
				form.patchValue({
					dob: date.toDate(),
					gender: gender
				});
			}
		});

		frmArray.push(form);
	}

	deleteDriver(i: number) {
		let frmArray = this.getFormArray();
		frmArray.removeAt(i);
	}

	async selectQuotation(id: string) {
		let lastQuotationId = this.quotationId;
		this.quotationFrmGroup.controls.id.setValue(id);
		this.quotationId = id;
		this.selectedQuotation = this.quotationList.find((x) => x.id == id);

    this.isTakaful = this.selectedQuotation.isTakaful;

		this.isChubbIQ = (this.selectedQuotation.name == "Chubb" && this.selectedQuotation.isInstantQuotation)
		this.isGeneraliIQ = (this.selectedQuotation.name == "Generali" && this.selectedQuotation.isInstantQuotation)
		this.isZurichIQ = (this.selectedQuotation.name == "Zurich General Insurance Malaysia Berhad" || this.selectedQuotation.name == "Zurich General Takaful Malaysia Berhad") && this.selectedQuotation.isInstantQuotation;
		this.isTMIMIQ = (this.selectedQuotation.name == "Tokio Marine" && this.selectedQuotation.isInstantQuotation)
		this.isAllianzIQ = this.selectedQuotation.name == "Allianz" && this.selectedQuotation.isInstantQuotation;

    // perform E2E quotation validity check for Allianz's E2E quotations (only got 24 hours validity)
    if (this.isAllianzIQ && !this.isAllianzIQValidated) {
      this.ngxSpinnerService.show();

      try {
        const isE2EQuotationRefreshed = await firstValueFrom(
          this.motorDataDataService.checkAllianzE2EQuotationValidity(this.quotationId),
        );

        this.isAllianzIQValidated = true;

        if (isE2EQuotationRefreshed) {
          this.ngxSpinnerService.hide();
					this.selectQuotation(this.quotationId);
          this.alertService.openSnackBar("Allianz quotation refreshed.");

          return;
        }
      } catch (err) {
        window.location.href = "/";
        return;
      }

      this.ngxSpinnerService.hide();
    }
    
		this.router.navigate([], {
			queryParams: {
				id: id,
				partnerCode: this.partnerCode
			}
		});
		if (this.addOnList.length == 0) {
			this.getAddOn();
		} else if (lastQuotationId != this.quotationId) {
			this.addOnList = [];
			this.initAddOnForm();
			this.getAddOn();
			this.selectedAddOn = [];
			this.isDriverChecked = false;
			this.isFloodChecked = false;
		}
		this.getProductDocument();

	  this.insurerConfig();

		this.stepper.next();
	}

	editQuotation() {
		let dialogRef = this.dialog.open(EditQuotationsComponent, {
			data: {
				id: this.id,
				request: this.requestData,
				quotationList: this.quotationList
			},
			panelClass: "edit-quote-dialog"
		});

		dialogRef.afterClosed().subscribe((x) => {
			if (x) {
				let successDialog = this.dialog.open(SubmitSuccessDialogComponent, {
					data: this.requestData.email,
					panelClass: "success-dialog"
				});

				successDialog.afterClosed().subscribe(() => {
					window.location.reload();
				});
			}
		});
	}

	carDetails() {
		let dialogRef = this.dialog.open(CarDetailsDialogComponent, {
			data: this.requestData
		});

		dialogRef.afterClosed().subscribe((x) => {});
	}

	carPlan() {
		let dialogRef = this.dialog.open(CarPlanDialogComponent, {
			data: this.requestData
		});

		dialogRef.afterClosed().subscribe((x) => {});
	}

	getAddOnListByCategory(val: string) {
		return this.addOnList.filter((x) => x.category == val);
	}

	isAddOnSelected(item: ProductAddOnInterface) {
		return this.selectedAddOn.some((x) => x.id == item.id);
	}

	getPrice(item: ProductAddOnInterface, val?: any) {
		try {
			let evaluate = item.evaluate;
			let condition = item.condition;
			let customEvaluate = item.customEvaluate;

			if (item.code == "FGAP") {
				const priceList = eval(evaluate);
				const valNum = parseInt(val);
				return priceList[valNum];
			}

			if (item.code == "EWP") {
				let conditionList = eval(condition);

				const ewpObject = conditionList.filter((x) => val <= x.Max);
				this.ewpMileagePrice = ewpObject[0].Value || 0;
				return ewpObject[0].Value;
			}

			if (
				item.customCode === "Generali_UnlimitedDrivers" &&
				this.selectedAddOn.some((x) => x.code === "Flood")
			) {
				evaluate = customEvaluate.replace("{val}", item.evaluate);
			}

			// [PSSR-3203]: tiered windscreen rate based on entered Windscreen SI
			if (item.windscreenRate && val) {
				const { threshold, rateBelowThreshold, rateAboveThreshold } =
					item.windscreenRate;
				evaluate = `{val} * ${
					Number(val) < threshold ? rateBelowThreshold : rateAboveThreshold
				}`;
			}

			if (val) {
				evaluate = evaluate.replace("{val}", val);

				if (condition) {
					condition = condition.replace("{val}", val);
					if (item.isConditionFirst) {
						let status = Boolean(eval(condition));
						if (status) {
							return eval(evaluate);
						} else {
							return 0;
						}
					}
				}
			}

			if (item.category === "CART") {
        const cartPrice = this.cartAddOnPriceList.filter((x) => x.days.toString() == this.selectedCartDays && x.coverage.toString() == this.selectedCartDailyCoverage)
        evaluate = cartPrice.length > 0 ? cartPrice[0]?.price.toString() : null;
      }

			return eval(evaluate);
		} catch {
			return 0;
		}
	}

	toggleAddOn(e: MatCheckboxChange) {
		let value: ProductAddOnInterface = e.source.value as any;

		if (e.checked) {
			this.selectedAddOn.push(value);

      if (value.category !== "PSXTRA" && !value.isIncludeSST) {
        this.selectedNonSSTAddOnToDisplay.push(value);
      }
		} else {
			let index = this.selectedAddOn.findIndex((x) => x.id == value.id);
			if (index >= 0) {
				this.selectedAddOn.splice(index, 1);
			}

      let nonSSTIndex = this.selectedNonSSTAddOnToDisplay.findIndex(
        (x) => x.id == value.id
      );
      if (nonSSTIndex >= 0) {
        this.selectedNonSSTAddOnToDisplay.splice(nonSSTIndex, 1);
      }

			if (value.category === "CART") {
        this.selectedCartDays = this.cartDayList[0].codeValue;
        this.selectedCartDailyCoverage = this.cartDailyCoverageList[0].codeValue;
        this.addOnFrmGroup.controls.cartDays.setValue(this.selectedCartDays);
        this.addOnFrmGroup.controls.cartDailyCoverage.setValue(this.selectedCartDailyCoverage);
      }
      if (value.category === "GCKT") {
        this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
      }
      if (value.category === "VA") {
        this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
      }
		}
		if (value.category == "Drivers") {
			let frmArray = this.getFormArray();
			frmArray.reset();
			frmArray.clear();
			if (e.checked && value.code == "AdditionalDrivers") this.addDriver();
		}
		if (value.category == "EWP") {
			if (e.checked) {
				this.addOnFrmGroup.controls.ewp.setValidators([
					Validators.max(this.ewpMileageMax),
					Validators.required
				]);
			} else {
				this.addOnFrmGroup.controls.ewp.clearValidators();
			}
			this.addOnFrmGroup.controls.ewp.updateValueAndValidity();
		}
		if (value.category == "Windshield") {
			if (e.checked) {
				this.addOnFrmGroup.controls.windshield.setValidators([
					Validators.min(this.windshieldMin),
					Validators.max(this.windshieldMax),
					Validators.required
				]);
				// PSSR-1361: set isWindshieldExceeded to required once Windshield is checked, only for Zurich & Zurich_Takaful
				if ((this.selectedQuotation.code == "Zurich" || this.selectedQuotation.code == "Zurich_Takaful") && !this.requestData?.isCompany) {
					this.addOnFrmGroup.controls.isWindshieldExceeded.setValidators([
						Validators.requiredTrue
						]);
				}
			} else {
				this.addOnFrmGroup.controls.windshield.clearValidators();
				this.addOnFrmGroup.controls.windshield.setValue(
					this.getMinMaxWindscreenPrice(value, "min")
				);
				// PSSR-1361: set isWindshieldExceeded to non-required once Windshield is unchecked, only for Zurich & Zurich_Takaful
				if ((this.selectedQuotation.code == "Zurich" || this.selectedQuotation.code == "Zurich_Takaful") && !this.requestData?.isCompany) {
					this.addOnFrmGroup.controls.isWindshieldExceeded.clearValidators();
				}
			}
			this.addOnFrmGroup.controls.windshield.updateValueAndValidity();
			this.addOnFrmGroup.controls.isWindshieldExceeded.updateValueAndValidity();
		}
		this.clearPromoCode();
	}

	getListDropdowns() {
		this.transferOwnershipDataService.getHirePurchaseList().subscribe((x) => {
			this.hirePurchaseList = x;
			this.filteredHirePurchase =
				this.infoFrmGroup.controls.bank.valueChanges.pipe(
					startWith(""),
					map((value) =>
						this.filterAutocompleteList(value || "", this.hirePurchaseList)
					)
				);
		});

		this.filteredDealerOutletsList =
			this.infoFrmGroup.controls.dealerOutlets.valueChanges.pipe(
				startWith(""),
				map((value) =>
					this.filterAutocompleteList(value || "", this.dealerOutletsList)
				)
			);
	}

	paymentTypeChange(paymentType: string) {
		this.selectedPayment = paymentType;
	}

	radioChange(e: ProductAddOnInterface, isCheckbox: boolean = false) {
		let index = this.selectedAddOn.findIndex((x) => x.category == e.category);
		if (index >= 0) this.selectedAddOn.splice(index, 1);
		if (!isCheckbox || index == -1) {
			this.selectedAddOn.push(e);
		}

		let frmArray = this.getFormArray();
		if (frmArray.length == 0 && e.code == "AdditionalDrivers") this.addDriver();
		else {
			frmArray.reset();
			frmArray.clear();
		}
	}

	getRule(e: ProductAddOnInterface) {
		if (e.rules) {
			return JSON.parse(e.rules);
		}
		return null;
	}

	hasSelectedCode(val: string) {
		return this.selectedAddOn.some((x) => x.code == val);
	}

	hasSelectedCategory(val: string) {
		return this.selectedAddOn.some((x) => x.category == val);
	}

	// -- Not used anymore at #freeDriverText
	// getConditionMax(e: ProductAddOnInterface) {
	//   if (e.code != 'AdditionalDrivers' || !e.condition) return 0;
	//   let count = 1;
	//   for (let index = 1; index < 9999; index++) {
	//     let condition = e.condition.replace('{val}', index.toString());
	//     let status = Boolean(eval(condition));
	//     if (status) {
	//       count = index - 1;
	//       break;
	//     }
	//   }
	//   return count;
	// }

	getGrossPremium() {
		if (!this.requestData && !this.selectedQuotation) return 0;

		return this.selectedQuotation?.totalBasePremium + this.getTotalAddOnPrice();
	}

	getTotalAddOnPrice() {
		let total = 0;

		this.selectedAddOn.forEach((x) => {
			if (x.isIncludeSST) {
				if (x.code == "AdditionalDrivers")
					total += this.getPrice(x, this.getFormArray().length);
				else if (x.category == "Windshield")
					total += this.getPrice(x, this.addOnFrmGroup.value.windshield);
				else if (x.category == "FGAP") {
					if (this.addOnFrmGroup.value.fgap) {
						total += this.addOnFrmGroup.value.fgap;
					} else {
						total += this.getPrice(x, "0");
					}
				} else if (x.category == "EWP") {
					total += this.getPrice(x, this.addOnFrmGroup.value.ewp);
				} else if (x.category == "LLTP") {
					total += this.getPrice(x, this.numberOfLltpSeats);
				}
				else if (x.category == "GCKT")
					total += this.getPrice(x, this.addOnFrmGroup.value.gckt);
				else if (x.category == "VA")
					total += this.getPrice(x, this.addOnFrmGroup.value.va);
				else if (x.customCode === "Generali_UnlimitedDrivers")
					total += this.getPrice(x, Number(x.evaluate));
				else if (x.customCode === "UnlimitedTowing_PA")
        	total += this.getPrice(x, this.numberOfLltpSeats);
				else total += this.getPrice(x);
			}
		});

		if (this.isCarPlusChecked) {
		total += this.getPrice(this.selectedAvailableInsurerCarPlus);
		}

		return total;
	}

	getTax() {
		if (!this.selectedQuotation) return 0;
		let total = this.getGrossPremium();

		return total * this.selectedQuotation.taxRate;
	}

	getTotalNetPremium() {
		var total =
			Number(this.getGrossPremium().toFixed(2)) +
			Number(this.getTax().toFixed(2)) +
			this.selectedQuotation?.stampDutyPrice;
		total =
			this.selectedQuotation &&
			(this.selectedQuotation.code.toLowerCase() === "takaful_malaysia" || this.selectedQuotation.code.toLowerCase() === "allianz")
				? CommonFunction.customSTMBRound(total)
				: total;

		return total;
	}

  /**
   * Flat bundle price, or 0 when Care+ is unavailable or unticked. Kept out of
   * getGrossPremium() so it is not part of the SST base - it is charged after
   * Total Net Premium, alongside the non-SST add-ons.
   */
  getPsCarePlusPrice() {
    if (!this.isPsCarePlusChecked || !this.selectedPsCarePlus) return 0;

    return this.getPrice(this.selectedPsCarePlus);
  }

  getTotalNonSSTAddOnPrice() {
    let total = 0;
    const filteredAddOns = this.selectedAddOn.filter(
      (x) => !x.isIncludeSST
    );
    filteredAddOns.forEach((x) => {
      if (x.customCode === "UnlimitedTowing_PA") {
        total += this.getPrice(x,this.numberOfLltpSeats);
      }
      else{
        total += this.getPrice(x);
      }
    });
    return total;
  }

	getPlatformDiscountRate() {
		return (
			this.selectedQuotation?.platformDiscountRate * this.getGrossPremium()
		);
	}

	getTotalPromo() {
		if (!this.promo) return 0;

		let evaluate = this.promo.evaluate;
		evaluate = evaluate.replace(
			"{TotalGrossPremium}",
			this.getGrossPremium().toString()
		);
		return Number.parseFloat(eval(evaluate));
	}

	getTotalCharge() {
		let total =
			this.getTotalNetPremium() +
			this.getTotalNonSSTAddOnPrice() +
			this.getPsCarePlusPrice() -
			this.getPlatformDiscountRate();
		if (this.addOnFrmGroup.value?.isIncludeRoadtax) {
			total =
				total +
				this.requestData.roadTaxPrice +
				this.requestData.roadTaxDeliveryPrice;
		}
		return total;
	}

	getServiceFee() {
		if (!this.selectedQuotation) return 0;
		return (
			this.selectedQuotation.serviceTaxRate *
			(this.getTotalCharge() - this.getTotalPromo())
		);
	}

	getTotal() {
		return this.getTotalCharge() + this.getServiceFee() - this.getTotalPromo();
	}

	getIdentityNoLabel() {
		if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
			return "common.icNo";
		else if (!this.requestData?.isMalaysian) return "common.passport";
		return "common.businessRegistrationNo";
	}

	getNameLabel() {
		if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
			return "common.namePerIc";
		else if (!this.requestData?.isMalaysian) return "common.namePerPassport";
		return "common.companyName";
	}

	isAddressValid() {
		return !(
			this.infoFrmGroup.controls.address.invalid ||
			this.infoFrmGroup.controls.address2.invalid ||
			this.infoFrmGroup.controls.city.invalid ||
			this.infoFrmGroup.controls.state.invalid
		);
	}

	isSameAddressChecked() {
		if (!this.isAddressValid()) {
			return false;
		}
		let value = this.infoFrmGroup.getRawValue();
		let addr = `${value.address || ""}${value.address2 || ""}${
			value.city || ""
		}${value.postcode || ""}${value.state || ""}`;
		let deliveryAddr = `${value.deliveryAddress || ""}${
			value.deliveryAddress2 || ""
		}${value.deliveryCity || ""}${value.deliveryPostcode || ""}${
			value.deliveryState || ""
		}`;
		return addr == deliveryAddr;
	}

	addressIsChecked(e: MatCheckboxChange) {
		this.isSameAddressCheck = e.checked;
		let validatorList = e.checked ? [] : [Validators.required];
		if (!e.checked) {
			this.infoFrmGroup.controls.deliveryAddress.reset();
			this.infoFrmGroup.controls.deliveryAddress2.reset();
			this.infoFrmGroup.controls.deliveryCity.reset();
			this.infoFrmGroup.controls.deliveryPostcode.reset();
			this.infoFrmGroup.controls.deliveryState.reset();
		}

		this.infoFrmGroup.controls.deliveryAddress.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryAddress2.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryCity.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryPostcode.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryState.setValidators(validatorList);

		this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
	}

  onDeclarationCheckboxChange(item: any): void {
    item.checked = !item.checked;

    if (this.declarationCheckboxController.find(x => x.checkbox == "isRead").checked &&
      this.declarationCheckboxController.find(x => x.checkbox == "isConfirm").checked) {
      this.isAgree = true;
    }
    else
      this.isAgree = false;
  }

	submit() {
		this.ngxSpinnerService.show();

		if (this.isAllianzIQ) {
      this.motorDataDataService.checkAllianzPremiumsBeforePayment(
				this.quotationId,
				this.selectedAddOn,
				this.addOnFrmGroup.value.windshield,
				this.addOnFrmGroup.value.cartDays,
				this.addOnFrmGroup.value.cartDailyCoverage,
				this.addOnFrmGroup.value.gckt,
				this.addOnFrmGroup.value.drivers
      ).subscribe(
        {
          next: (x: any) => {
            this.ngxSpinnerService.hide();
            
            if (x.isPremiumsValid) {
              this.getAgentCode();
            }
            else {
              this.alertService.openSnackBar(x.checkingRemarks);
            }
          },
          error: () => {
            this.ngxSpinnerService.hide();
            this.alertService.openSnackBar("Failed to process Allianz order, please contact Policy Street.");
          }
        }
      );
    }
		else if (this.isZurichIQ) {
			// before checking out, run GET PREM again to update Zurich's quotation with info below:
			//	- latest premiums (in case got repricing, will hit validation error during SubmitOrder)
			//	- personal details
			//	- finance details
			let isHirePurchase = (this.requestData.businessType == this.businessTypeOption.transferOwnership && this.infoFrmGroup.value.financingType == "BankLoan");
			let loanCompanyName = (isHirePurchase) ? this.infoFrmGroup.value.bank : "";
			let hirePurchaseEffDate = this.formatDate(this.infoFrmGroup.value.effectiveDate);

			this.motorDataDataService.getZurichQuotationPricing(
				this.quotationId,
				this.selectedAddOn,
				this.addOnFrmGroup.value.drivers,
				this.addOnFrmGroup.value.windshield,
				this.infoFrmGroup.value.address,
				this.infoFrmGroup.value.address2,
				this.infoFrmGroup.value.city,
				isHirePurchase,
				loanCompanyName,
				hirePurchaseEffDate
			).subscribe({
				next: (x: any) => {
					this.ngxSpinnerService.hide();
					this.getAgentCode();
				},
				error: (err: any) => {
					this.ngxSpinnerService.hide();

					let errMsg = "Premium calculation failed, please contact Policy Street.";
					if (err.error)
						errMsg = err.error;

					this.alertService.openSnackBar(errMsg);
				}
			});
		}
    else {
      this.getAgentCode();
			this.ngxSpinnerService.hide();
    }
	}

	getAgentCode() {
		let dialogRef = this.dialog.open(AgentCodeDialogComponent, {
			panelClass: "agent-code-dialog",
			data: {
				id: this.id,
				quotationId: this.quotationId,
				selectedAddOn: this.selectedAddOn,
				addOnValue: this.addOnFrmGroup.value,
				infoValue: this.infoFrmGroup.value,
				mykadOrPassport: this.mykadOrPassport,
				letterOfUndertaking: this.letterOfUndertaking,
				fgapAddOnsIndex: this.fgapAddOnsIndex,
				includeRoadTax: this.addOnFrmGroup.value?.isIncludeRoadtax,
				vehiclePhoto: this.vehiclePhoto,
				ewpAmount: this.ewpMileagePrice,
				ewpFiles: this.ewpFiles,
				promoCodeId:
					this.promo?.id !== null && typeof (this.promo?.id !== undefined)
						? this.promo?.id
						: null,
				isGeneraliIQ: this.isGeneraliIQ,
				isChubbIQ: this.isChubbIQ,
				isCarPlusChecked: this.isCarPlusChecked,
				selectedCarPlusId: this.isCarPlusChecked ? this.selectedAvailableInsurerCarPlus.id : null,
				selectedPlanPremium: this.isCarPlusChecked ? this.getPrice(this.selectedAvailableInsurerCarPlus) : null,
				isPsCarePlusChecked: this.isPsCarePlusChecked,
				selectedPsCarePlusId:
					this.isPsCarePlusChecked && this.selectedPsCarePlus ? this.selectedPsCarePlus.id : null,
				insurer: this.selectedQuotation.name
			}
		});

		dialogRef.afterClosed().subscribe((x) => {
			if (x) {
				this.router.navigate(["/"], {
					queryParams: {
						partnerCode: this.partnerCode
					}
				});
			}
		});
	}

	getFormArrayControlError(i, formControlName) {
		return (this.getFormArray().controls[i] as UntypedFormGroup).controls[
			formControlName
		].errors;
	}

	benefitDialog(item) {
		this.dialog.open(BenefitDialogComponent, {
			panelClass: "benefit-dialog",
			data: {
				productId: item.productId,
				code: item.code,
				lang: this.translate.currentLang,
				insuranceType: this.requestData.insuranceType
			}
		});
	}

	getAddOnCode(code) {
		return `addOn.${code}`;
	}

	hasAddOn() {
		return this.selectedAddOn.filter((x) => !x.hidePriceBreakdown && x.isIncludeSST).length != 0;
	}

	addonLabel(value: number) {
		return "RM " + value.toFixed(2).toLocaleString();
	}

	getPrintedQuotation(id: string) {
		this.selectedQuotation = this.quotationList.find((x) => x.id == id);
	}

	printComparison(id: string) {
		this.getPrintedQuotation(id);

		this.print();
	}

	print() {
		// for Chubb IQ, execute GEN QUOTATION before printing the quotation summary
		//	- this is to ensure the quotation record is created in eBiz before showing the quotation summary to customers
		if (this.isChubbIQ) {
			this.ngxSpinnerService.show();

			const genQuotationInfo: ChubbGenQuotationInfoInterface = {
				mobileNo: "+06121231234",
				address1: "dummy address for GEN QUOTATION",
				address2: "",
				city: "",
				state: "",
				isHirePurchase: false,
				loanCompany: "",
				effectiveDate: null
			}

			this.motorDataDataService.processChubbOrder(this.quotationId, genQuotationInfo).subscribe({
				next: (x: any) => {
					this.ngxSpinnerService.hide();

					if (x.genQuotationResult) {
						this.alertService.openSnackBar("Quotation generated in Chubb");
						this.chubbIQQuotationNo = `(${x.chubbQuotationNo})`;
						this.printQuotationSummary();
					}
					else {
						if (x.genQuotationMessage.includes('Error: ')) {
							this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
						}
						else {
							this.alertService.openSnackBar(x.genQuotationMessage);
						}
					}
				},
				error: () => {
					this.ngxSpinnerService.hide();
					this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
				}
			})
		}
		else {
			this.printQuotationSummary();
		}
	}

	printQuotationSummary() {
		const printContent = document.getElementById("printOrderSummary");
		const iframe = document?.getElementById("iframePrint") as HTMLIFrameElement;

		if (iframe && printContent) {
			const html = printContent.innerHTML;
			const updatedHtml = html.replace('{{chubbIQQuotationNo}}', this.chubbIQQuotationNo);

			const printWindow = iframe.contentWindow;
			const doc = printWindow?.document;

			if (doc) {
				doc.open();
				doc.writeln(`
					<html>
						<head>
						<style>
							@media print {
								body {
									-webkit-print-color-adjust: exact !important;
									color-adjust: exact !important;
									print-color-adjust: exact !important;
								}
							}
							@page { margin: 0; }
							body { font-family: "Open Sans", sans-serif; }

							.summary-main-container {
								max-width: 900px; 
								height: 100%; 
								padding: 5px 15px; 
								background-color: #c5f2f9; 
								border-radius: 5px;
							}
								.summary-info-header {
									color: #203570; 
									font-size: 18px;
								}
								.summary-info-container {
									background-color: #f4f6fa80; 
									border-radius: 10px; 
									padding: 20px; 
									margin: 5px 0px 15px 0px;
									font-size: 14px;
								}
								.summary-disclaimer {
									font-style: italic; 
									font-size: 13px; 
									margin-top: 5px;
								}
									.summary-disclaimer img {
										width: 15px; 
										margin-right: 8px;
									}
								.summary-footer {
									right: 15px; 
									bottom: 15px;

									&-brand-title {
										font-weight: 600; 
										font-size: 13px;
									}

									&-brand-content {
										font-style: italic;
									}
								}
								
								.row-bg-white {
									font-weight: bold; 
									margin: 10px 0px; 
									background-color: #f4f6faFF;
								}
								.total-amount {
									style="font-weight: bold; 
									margin-top: 10px; 
									color: #0091ff; 
									background-color: #f4f6faFF;"
								}
						</style>
						</head>
						<body>
							${updatedHtml}
						</body>
					</html>
				`);
				doc.close();

				iframe.onload = () => {
					printWindow?.focus();
					printWindow?.print();
				};
			}
		}
	}

	handleFileInput(e, name = null) {
		const files = e.target.files;
		if (files.length) {
			for (let i = 0; i < files.length; i++) {
				let file: File = e.target.files[i];
				if (!FileFunction.isImageOrPdf(file)) {
					this.alertService.openSnackBar(
						`Fail to upload ${file.name} - just accept image type (jpeg, png & svg)`
					);
					return;
				}
				if (!name) {
					this[e.target.name].push(files[i]);
				} else {
					this[e.target.name][name].push(files[i]);
				}
			}
		}

		e.target.value = "";
	}

	deleteFile(file: any, index: number, name = null) {
		if (!name) {
			this[file].splice(index, 1);
		} else {
			this[file][name].splice(index, 1);
		}
	}

	dealerCaseChanged(e: any) {
		if (e.value) {
			let dialogRef = this.dialog.open(DealerCaseDialogComponent, {
				panelClass: "success-dialog",
				disableClose: true,
				autoFocus: false
			});

			dialogRef.afterClosed().subscribe((x) => {
				if (x) {
					this.infoFrmGroup.patchValue({
						dealerCase: false
					});
				}
			});
		}
	}

	filterAutocompleteList(value: string, list: string[]) {
		if (value) {
			const filterValue = value.toLowerCase();

			return list.filter((x) => x.toLowerCase().includes(filterValue));
		}
		return list;
	}

	getUserDetailsBtnCondition(): boolean {
		if (
			this.requestData.businessType == this.businessTypeOption.transferOwnership
		) {
			if (
				this.infoFrmGroup.invalid ||
				!this.mykadOrPassport.length ||
				!this.letterOfUndertaking.length ||
				!this.vehiclePhoto.length
			) {
				return true;
			} else {
				return false;
			}
		} else if (
			this.requestData.businessType == this.businessTypeOption.renewal
		) {
			if (this.infoFrmGroup.invalid) {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}

	openCarVariantDialog(id: string) {
		let dialogRef = this.dialog.open(CarVariantDialogComponent, {
			panelClass: "edit-quote-dialog",
			data: { requestData: this.requestData, linkId: this.id },
			autoFocus: false
		});

		dialogRef.afterClosed().subscribe((result: any) => {
			if (result && result.data === true) {
				this.selectQuotation(id);
			}
		});
	}

	getMinMaxWindscreenPrice(
		addOn: ProductAddOnInterface,
		key: "min" | "max"
	): number {
		const rule = this.getRule(addOn);
		const { maxWindshieldPrice, minWindshieldPrice } = this.selectedQuotation;

		const config = {
			max: maxWindshieldPrice || rule?.max || 10000,
			min: minWindshieldPrice || rule?.min || 500
		};

		return config[key];
	}

	getPartnerLogo() {
		if (this.partnerCode == "carsomeCapital")
			return "https://storage.googleapis.com/ps-asset/ps_logos/ps_carsome_logo.png";
		else
			return "https://storage.googleapis.com/ps-asset/ps_logos/ps_digirep_logo.png";
	}

  get getSILabelName() {
    return this.isTakaful ? "common.sumCovered" : "common.sumInsured";
  }

  get getInsuranceLabelName() {
    return this.isTakaful ? "common.typeOfTakaful" : "common.typeOfInsurance";
  }

  get getBasePremLabelName() {
    return this.isTakaful ? "common.baseContribution" : "common.basePremium";
  }

  get getTotalBasePremLabelName() {
    return this.isTakaful ? "common.totalBaseContribution" : "common.totalBasePremium";
  }

  get getTotalGrossPremLabelName() {
    return this.isTakaful ? "common.totalGrossContribution" : "common.totalGrossPremium";
  }

  get getTotalNetPremLabelName() {
    return this.isTakaful ? "common.totalNetContribution" : "common.totalNetPremium";
  }

	private getCARTAddOnPriceList() {
    this.motorDataDataService.getCARTAddOnPriceList().subscribe({
      next: (x: MotorAddOnCARTPriceInterface[]) => {
        this.cartAddOnPriceList = x;
      }
    });
  }

  getExpiryDate(date: string | Date): Date | null {
    if (!date) return null;

    const start = new Date(date);
    const end = new Date(start);

    end.setFullYear(end.getFullYear() + 1); // +1 year
    end.setDate(end.getDate() - 1);         // -1 day

    return end;
  }

    /* Insurer Car Plus */
  private initInsurerCarPlus() {
    const list = this.addOnList
      .filter(x => x.category === 'MYCARPLUS')
      .sort((a, b) => a.seq - b.seq);

    this.availableInsurerCarPlus = list;
    this.selectedAvailableInsurerCarPlus = list[0] ?? null;

    if (!this.selectedAvailableInsurerCarPlus) {
      this.insurerCarPlusPackage = null;
      return;
    }

    const carPlusPackage = this._insurerCarPlusPackage[this.selectedQuotation.name];

    this.insurerCarPlusPackage =
      carPlusPackage?.packages.find(
        x => x.insurerCustomCode == this.selectedAvailableInsurerCarPlus.insurerCustomCode
      ) ?? null;

    this.insurerCarPlusSettings = carPlusPackage?.settings;

    this.isCarPlusChecked = this.insurerCarPlusSettings.isMandatory
  }

  /**
   * PolicyStreet Care+ is a partner bundle, not an insurer product: the backend
   * returns the PSCAREPLUS row only for partners entitled to it, so the row's
   * presence IS the eligibility check and no partner code is tested here.
   *
   * Deliberately not driven from insurerConfig(): that resets isCarPlusChecked
   * on every insurer change, which is right for MyCar Plus (priced per insurer)
   * but would silently untick Care+ while the customer compares insurers.
   */
  private initPolicyStreetCarePlus() {
    const list = this.addOnList
      .filter((x) => x.category === "PSCAREPLUS")
      .sort((a, b) => a.seq - b.seq);

    this.availablePsCarePlus = list;
    this.selectedPsCarePlus = list[0] ?? null;

    if (!this.selectedPsCarePlus) {
      this.psCarePlusSettings = null;
      this.isPsCarePlusChecked = false;
      return;
    }


    const isTransferOwnership =
      this.requestData?.businessType ===
      this.businessTypeOption.transferOwnership;

    this.psCarePlusSettings = {
      ...this._psCarePlusPackage.settings,
      isMandatory: isTransferOwnership
    };

    // Included by default in every journey; only the ability to untick differs.
    this.isPsCarePlusChecked = true;
  }

  get isPsCarePlusBannerBm(): boolean {
    return this.translate.currentLang === "bm";
  }

  get psCarePlusBanner(): string {
    return this.isPsCarePlusBannerBm
      ? this._psCarePlusPackage.banner.bm
      : this._psCarePlusPackage.banner.en;
  }

  toggleInsurerCarPlusBenefits() {
    this.showAllBenefits = !this.showAllBenefits;
  }

  onInsurerCarPlusPlanChange(code: any) {
    let selectedCarPlus = this._insurerCarPlusPackage[this.selectedQuotation.name];
    this.insurerCarPlusPackage = selectedCarPlus.packages.find(x => x.insurerCustomCode == code);

    this.selectedAvailableInsurerCarPlus = this.availableInsurerCarPlus.find(x => x.insurerCustomCode == code);
  }

  get displayedBenefits() {
    const benefits = this.insurerCarPlusPackage?.benefits || [];
    return this.showAllBenefits ? benefits : benefits.slice(0, this.benefitsLimit);
  }

  insurerConfig() {
	// reset
    this.isCarPlusChecked = false;

    this.showEffectivePeriod = false;
    this.showISMRecommended = false;
    this.showAgencyCommission = false;
    this.showTypeOfSumValue = this.selectedQuotation?.typeOfSum;

    if (this.selectedQuotation?.code == 'Chubb') {
	    this.isCarPlusChecked = true;

      this.showEffectivePeriod = true;
      this.showISMRecommended = true;
      this.showTypeOfSumValue = "MV"; //Chubb will display Market Value (even though is Agree Value)
      this.showAgencyCommission = true;
    }
  }

  getPSComissionPrice() {
    let comission = this.getGrossPremium() * (10 / 100);
    return Number(comission.toFixed(2));
  }

  formatDate(inputDate: any) {
		if (!inputDate) {
			return null;
		}

		const date = new Date(inputDate);

		const formattedDate =
		date.getFullYear() + "-" +
		String(date.getMonth() + 1).padStart(2, '0') + "-" +
		String(date.getDate()).padStart(2, '0') + "T" +
		String(date.getHours()).padStart(2, '0') + ":" +
		String(date.getMinutes()).padStart(2, '0') + ":" +
		String(date.getSeconds()).padStart(2, '0') +
		"+08:00";

		return formattedDate;
	}

  get getMinSI() {
    if (this.selectedQuotation?.typeOfSum == "AV"){
      return this.selectedQuotation?.minAVSI;
    }

    return this.selectedQuotation?.minMVSI;
  }

  get getMaxSI() {
    if (this.selectedQuotation?.typeOfSum == "AV"){
      return this.selectedQuotation?.maxAVSI;
    }

    return this.selectedQuotation?.maxMVSI;
  }
}

interface FieldData {
	codeValue: string;
	codeDesc: string;
}
